import { Text as BPText } from '@resideo/blueprint-react';
import styled, { css } from 'styled-components';
import { TitleProps } from './Typography';

const sharedStyle = css<TitleProps>`
  ${({
    strong = 'false',
    italic = false,
    underline = false,
    marginBottom,
    marginTop,
    textAlign,
    paddingRight,
    paddingLeft,
  }) => css`
    ${strong === 'true' ? 'font-weight: 500;' : ''}
    ${italic ? 'font-style: italic;' : ''}
  ${underline ? 'text-decoration: underline;' : ''}
  ${marginTop ? `margin-top: ${marginTop.toString()};` : ''}
  ${marginBottom ? `margin-bottom: ${marginBottom.toString()};` : ''}
  ${textAlign ? `text-align: ${textAlign};` : ''}
  ${paddingRight ? `padding-right: ${paddingRight.toString()};` : ''}
  ${paddingLeft ? `padding-left: ${paddingLeft.toString()};` : ''}
  `}
`;

const styleMobile = css<TitleProps>`
  ${({ level }) => css`
    ${level &&
    `margin-bottom: ${[null, '18px', '18px', '16px', '16px', '16px', '16px'][level]};`}
    ${level &&
    `font-size: ${[null, '28px', '24px', '18px', '18px', '18px', '18px'][level]};`}
  `}
`;

const styleDesktop = css<TitleProps>`
  ${({ level }) => css`
    ${level &&
    `margin-bottom: ${[null, '16px', '16px', '16px', '16px', '16px', '16px'][level]};`}
    ${level &&
    `font-size: ${[null, 'xxLarge', 'xLarge', 'large', 'large', 'medium', 'small'][level]};`}
  `}
`;

export const StyledTitle = styled<any>(BPText)`
  font-weight: 500;
  margin-top: 0;
  ${sharedStyle}
  ${styleDesktop}
`;

export const StyledText = styled<any>(BPText)`
  ${sharedStyle}
`;

export const StyledTitleMobile = styled<any>(BPText)`
  margin: 0;
  ${sharedStyle}
  ${styleMobile}
`;

export const StyledTextMobile = styled<any>(BPText)`
  font-size: 18px;
  ${sharedStyle}
`;
